export const SITE_URL = "https://fabbuildpro.com";
export const BIZ_ID = `${SITE_URL}/#business`;
export const WEBSITE_ID = `${SITE_URL}/#website`;
export const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
export const BIZ_REF = { "@type": "RoofingContractor", "@id": BIZ_ID, name: "Fab Build Pro" };

// Cities that have a dedicated roofing landing page (preferred URL for "roofing/roof repair in X").
export const LANDING_BY_CITY = {
  vienna: "/roofing-contractor-vienna-va",
  mclean: "/roofing-contractor-mclean-va",
};

// "Vienna, VA" / "Rockville, MD" / "Northern Virginia"
export const placeName = (area) => {
  const m = area.region.match(/,\s*([A-Z]{2})$/);
  return m ? `${area.name}, ${m[1]}` : area.name;
};

// Old WordPress URLs (from Google Search Console) -> current equivalent pages.
const LEGACY = {
  "/services/gutters-services": "/services/gutters",
  "/services/windows-services": "/services/windows",
  "/services/doors-services": "/services/doors",
  "/services/siding-services": "/services/siding",
  "/services/interior-remodel-services": "/services/remodeling",
  "/services/roofing-services": "/services/roofing",
  "/siding": "/services/siding",
  "/home-exterior-additions-experts-in-washington-dc": "/services/siding",
  "/roof-maintenance-in-northern-virginia-what-to-do": "/roof-maintenance",
  "/top-roof-maintenance-tips-you-need-to-know": "/blog/roof-maintenance-guide-dmv",
  "/planning-a-roof-replacement-here-are-the-top-mistakes-to-avoid": "/services/roof-replacement",
  "/types-of-asphalt-roofing-shingles": "/services/roof-replacement",
  "/top-10-signs-your-roof-needs-repair-or-replacement-explained": "/blog/signs-you-need-a-new-roof",
  "/key-signs-your-roof-needs-repair-or-replacement-in-virginia": "/blog/signs-you-need-a-new-roof",
  "/seven-signs-your-roof-may-need-to-be-replaced-soon": "/blog/signs-you-need-a-new-roof",
  "/signs-its-time-for-roof-replacement": "/blog/signs-you-need-a-new-roof",
  "/six-reasons-to-choose-fab-build-pro-for-your-next-roofing-project": "/about",
  "/ice-and-winter-storm-roof-damage-what-to-do": "/storm-damage-roof-repair-virginia",
  "/roof-repair-in-northern-virginia-choosing-the-right-roofing-material": "/services/roof-repair",
  "/common-roof-problems-to-watch-in-northern-virginia": "/services/roof-repair",
  "/understanding-roofing-services-in-northern-virginia": "/services/roofing",
  "/what-to-look-for-in-northern-virginia-roofing-contractors": "/blog/roofing-company-vienna-va",
  "/key-factors-to-consider-when-choosing-a-roofing-contractor": "/blog/roofing-company-vienna-va",
  "/how-to-choose-the-right-roofing-contractor-for-your-home": "/blog/roofing-company-vienna-va",
  "/five-things-to-keep-in-mind-when-choosing-a-roofing-contractor": "/blog/roofing-company-vienna-va",
  "/key-factors-to-choose-the-best-siding-installation-company": "/blog/best-siding-for-dmv-homes",
  "/signs-you-need-new-siding-for-your-home": "/blog/best-siding-for-dmv-homes",
  "/how-to-tell-if-your-siding-needs-replacement": "/blog/best-siding-for-dmv-homes",
  "/signs-you-need-siding-replacement-now": "/blog/best-siding-for-dmv-homes",
  "/contact-2": "/contact",
  "/terms-of-service": "/privacy-policy",
  "/terms-conditions": "/privacy-policy",
  "/home": "/",
};
const LEGACY_KEYS = Object.keys(LEGACY).sort((a, b) => b.length - a.length);

// Returns the path the visitor should be redirected to, or null.
export const resolveRedirect = (pathname) => {
  const p = pathname.toLowerCase().replace(/\/+$/, "") || "/";
  if (LEGACY[p]) return LEGACY[p];
  const prefix = LEGACY_KEYS.find((k) => p.startsWith(`${k}/`));
  if (prefix) return LEGACY[prefix];
  if (/^\/(category|author|tag|page|\d{4})(\/|$)/.test(p)) return "/blog";
  const sub = p.match(/^\/(about|reviews|contact|service-areas\/[^/]+)\/.+/);
  if (sub) return `/${sub[1]}`;
  if (p !== pathname) return p;
  return null;
};
